import Sidebar from "../sidebar/Sidebar";
import { fifthrows } from "../data/fifthrows";
import Footer from "../components/Footer";
import FifthRowCard from "../components/FifthRowCard";

const Education = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Sidebar page={"Education"} />
      <div className="flex-1 px-4 py-4 lg:px-8 lg:py-6 bg-lightBg text-lightText dark:bg-darkBg dark:text-darkText">
          <h1 className="text-2xl xl:text-3xl font-bold mb-4 text-lightText dark:text-darkText">
            Education
          </h1>

          <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-4">
              Fifth Rows / Co-Curricular Activities
            </h2>
            {fifthrows.map((item, index) => (
              <FifthRowCard
                key={index}
                organisation={item.organisation}
                role={item.role}
                duration={item.duration}
                jobscope={item.jobscope}
                repeat={item.repeat}
              />
            ))}
          </section>

          <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
              Projects
            </h2>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mb-2">
              See the{" "}
              <a href="/pre-phd" className="text-green dark:text-green-dark underline underline-offset-2">
                Background
              </a>{" "}
              page for more details on projects I did during my undergraduate
              and polytechnic studies.
            </p>
          </section>
          {/* <section>
            <h2 className="text-xl lg:text-2xl font-semibold text-lightText dark:text-darkText mb-2 mt-8">
              Online Courses
            </h2>
            <ol className="list-decimal break-normal text-sm">
              {onlinecourses.map((item, index) => (
                <li key={index} className="mb-4">
                  <p className="text-lg font-medium underline">{item.title}</p>
                  <div className="flex items-center mb-1">
                    <p className="flex-1">
                      {item.organisation} | {item.platform}
                    </p>
                    <p>{item.year}</p>
                  </div>
                  {item.description && (
                    <li>{item.description}</li>
                  )}
                  <a
                    href={item.credential}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2 hover:font-semibold text-green dark:text-green-dark"
                  >
                    View Credential
                  </a>
                </li>
              ))}
            </ol>
          </section> */}
      </div>
      <Footer />
    </div>
  );
};

export default Education;
